import { render, staticRenderFns } from "./ReportSales.vue?vue&type=template&id=20a5d06e&scoped=true&"
import script from "./ReportSales.vue?vue&type=script&lang=js&"
export * from "./ReportSales.vue?vue&type=script&lang=js&"
import style0 from "./ReportSales.vue?vue&type=style&index=0&id=20a5d06e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5d06e",
  null
  
)

export default component.exports